import { useQuery } from "@tanstack/react-query";
import { LOGO } from "../../../enums/QueryKeys";
import { fetchLogo } from "../../../enums/queryFunction/Fetch";
import useUser from "../../../hooks/useUser";

export default function useLogo() {
  const { currentClinic, roles, isLoading: userLoading } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: [LOGO],
    queryFn: () => fetchLogo(currentClinic?.id, roles.master),
    staleTime: Infinity,
    enabled: !userLoading,
  });

  if (data != undefined && data != null && data != "") {
    return data;
  }

  return null;
}
